export default __webpack_public_path__ + "static/media/votes_small.7dc3584c.svg";